export class IndicadoresVivosVModel {

    anio: number; // 2021,
    codigoArticulo: string; // "3031008",
    codigoCliente: string; // "100012",
    codigoVendedor: string; // "3113",
    contenedor: string; // "t02",
    dolares: number; // 100.0,
    isCorrect: boolean; // true,
    kilos: number; // 10.0,
    mes: number; // 8,
    nombreArticulo: string; // "TNP*220 LT AVG-100 (AC.VEG.AGR",
    nombreCliente: string; // "SEAFMAN C.A.",
    nombreVendedor: string; // "Moya Paredes Fabián Alberto",
    tipo: string; // 1,
    cajas: number; // "2"
    mtv: number;
    tipoPresupuesto: number;
    usuario?: string;
    version: number;
    pk?: []

    constructor() { }

    devolverGrid() {
        const obj: any = {
            anio: 'anio',
            codigoArticulo: 'codigoArticulo',
            codigoCliente: 'codigoCliente',
            codigoVendedor: 'codigoVendedor',
            contenedor: 'contenedor',
            dolares: 'dolares',
            isCorrect: 'isCorrect',
            kilos: 'kilos',
            mes: 'mes',
            nombreArticulo: 'nombreArticulo',
            nombreCliente: 'nombreCliente',
            nombreVendedor: 'nombreVendedor',
            tipo: 'tipo',
            cajas: 'cajas',
            mtv: 'mtv',
            ventaBruta: 'ventaBruta',
            material: 'material',
            nombreMaterial: 'nombreMaterial',
            tipoPresupuesto: 1,
            usuario: 'usuario',
            version: 20,
            sector: 'sector'
        }
        return obj;
    }

    devolverGridFacturasMarcas() {
        const obj: any = {
            version: 'version',
            anio: 'anio',
            codigoVendedor: 'codigoVendedor',
            nroMarcas: 'nroMarcas',
            isCorrect: 'isCorrect',
            nroFacturas: 'nroFacturas',
            mes: 'mes',
            nombreVendedor: 'nombreVendedor',
        }
        return obj;
    }
}

export interface IndicadoresVivosVModelInterface {
    anio: string;
    codigoArticulo: string;
    codigoCliente: string;
    codigoVendedor: string;
    contenedor: string;
    dolares: string;
    isCorrect: string;
    kilos: string;
    mes: string;
    nombreArticulo: string;
    nombreCliente: string;
    nombreVendedor: string;
    tipo: string;
    cajas: string;
    mtv: string;
    tipoPresupuesto: string;
    usuario: string;
    version: number;
}

export interface IndicadoresVivosVModeFacturasMarcaslInterface {
    version: string;
    anio: string;
    codigoArticulo: string;
    codigoCliente: string;
    codigoVendedor: string;
    contenedor: string;
    dolares: string;
    isCorrect: string;
    kilos: string;
    mes: string;
    nombreArticulo: string;
    nombreCliente: string;
    nombreVendedor: string;
    tipo: string;
    cajas: string;
    mtv: string;
}


////T25111 add presupuesto promocional
export interface PresupuestoPromocionalnterface{
    version: string;
    anio: string;
    codigoArticulo: string;
    codigoCliente: string;
    codigoVendedor: string;
    contenedor: string;
    dolares: string;
    isCorrect: string;
    kilos: string;
    mes: string;
    nombreArticulo: string;
    nombreCliente: string;
    nombreVendedor: string;
    tipo: string;
    cajas: string;
    mtv: string;
}